var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7818 5.83333H16.6667C17.5872 5.83333 18.3333 6.57953 18.3333 7.5V10.8333C18.3333 11.7538 17.5872 12.5 16.6667 12.5H15.7818C15.3717 15.7886 12.5663 18.3333 9.16667 18.3333V16.6667C11.9281 16.6667 14.1667 14.4281 14.1667 11.6667V6.66667C14.1667 3.90524 11.9281 1.66667 9.16667 1.66667C6.40524 1.66667 4.16667 3.90524 4.16667 6.66667V12.5H1.66667C0.746192 12.5 0 11.7538 0 10.8333V7.5C0 6.57953 0.746192 5.83333 1.66667 5.83333H2.55158C2.96166 2.54474 5.76698 0 9.16667 0C12.5663 0 15.3717 2.54474 15.7818 5.83333ZM1.66667 7.5V10.8333H2.5V7.5H1.66667ZM15.8333 7.5V10.8333H16.6667V7.5H15.8333ZM5.63287 12.3208L6.51632 10.9073C7.28468 11.3885 8.19317 11.6667 9.16667 11.6667C10.1402 11.6667 11.0487 11.3885 11.817 10.9073L12.7005 12.3208C11.676 12.9624 10.4647 13.3333 9.16667 13.3333C7.86867 13.3333 6.65735 12.9624 5.63287 12.3208Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.f30733d6049969c290bc078fa3d274bf.svg";
export { ForwardRef as ReactComponent };